<template>
  <div :index="index" class="tab-pane">
    <dd-tab @click="onTabClick">
      <slot name="title"></slot>
    </dd-tab>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabContent.vue",
  emits: ['go-to-tab'],
  props: {
    index: {
      type: Number,
      required: true,
    },
  },

  methods: {
    onTabClick() {
      this.$parent.goToTab(this.index);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.tab-pane {
  padding: 0;
}
.tab-pane.active {
  .tab {
    background-color: $main-content-bg-color;
    color: $brand-primary;
  }
}
.tab-content {
  width: 100%;
  background-color: $main-content-bg-color;
  display: none;
}
.tab-content.active {
  display: flex;
}
</style>